<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
    [isConfigured]="isConfigured"
    (onIntegrate)="onIntegrate(response)"
    [description]="widgetRef.widgetDescription"
></app-integration>
